__webpack_require__.p = "/2024-luong-graphical-models/";